import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sliderList: [],
  sliderFormList: [],
  sliderDetail: [],
  success: false,
  loading: false,
  error: undefined,
};

const sliderSlice = createSlice({
  name: "slider",
  initialState,
  reducers: {
    clearError(state) {
      state.loading = false;
      state.success = false;
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    actionSuccess(state) {
      state.success = true;
    },
    fetchSliderList(state, action) {
      state.sliderList = action.payload;
      state.loading = false;
    },
    fetchSliderFormList(state, action) {
      state.sliderFormList = action.payload;
      state.loading = false;
    },
    fetchSliderDetail(state, action) {
      state.sliderDetail = action.payload;
      state.loading = false;
    },
  },
});

export const sliderActions = sliderSlice.actions;

export default sliderSlice.reducer;
